import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import SetPassword from '../../features/auth/components/SetPassword';

const SetPasswordRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <SetPassword />
    </ProtectedRoute>
  );
};

export default SetPasswordRoute;
